import './App.css';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { ErrorPage404 } from './components/errorPage/ErrorPage404';
import { FormSamplesNavigation } from './components/formSamples/FormSamplesNavigation';
import { LayoutContainer } from './components/layout/LayoutContainer';
import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
import { LoginPage } from './components/loginPage/LoginPage';
import { RedirectToLogin } from './components/loginPage/RedirectToLogin';
import { ListAndDetailsSamplesNavigation } from './components/listAndDetailSamples/ListAndDetailSamplesNavigation';
import { OtherSamplesNavigation } from './components/otherSamples/OtherSamplesNavigation';
import { ErrorPageGeneral } from './components/errorPage/ErrorPageGeneral';

// The samples show how you can incorporate azure ad authentication into your code, but is disabled by default
// with the below variable. You don't need to add this flag variable in your code, but rather just copy
// the code snippets it shows/hides (further down in the code) based on if you want AD authentication or not
const USE_AD_AUTHENTICATION = false;

const routerForUnauthorized = createBrowserRouter([
  {
    path: "/",
    element: <LoginPage />,
    errorElement: <ErrorPageGeneral />
  },
  {
    path: "*", element: <RedirectToLogin />
  }
])

const router = createBrowserRouter([
  {
    path: "/",
    element: <LayoutContainer />,
    errorElement: <ErrorPageGeneral />,
    // Try decouple the App.tsx component from specific navigation.
    // The App.tsx should know what types of routes there is, but not the details.
    // In this example the App.tsx knows theres FormSamplesRoutes, ListAndDetailSampleRoutes, etc.
    // If changes need to be made to the routes of Forms for example the App.tsx component is not affected at all.
    children: [
      ...FormSamplesNavigation(),
      ...ListAndDetailsSamplesNavigation(),
      ...OtherSamplesNavigation()
    ],
  },
  {
    path: "*", element: <ErrorPage404 />
  }
])

function App() {
  return (
    <div className="App">
      {USE_AD_AUTHENTICATION &&
        <>
          {/*
            If you are using AD authentication then you can copy this snippet
          */}
          <UnauthenticatedTemplate>
            <RouterProvider router={routerForUnauthorized} />
          </UnauthenticatedTemplate>
          <AuthenticatedTemplate>
            <RouterProvider router={router} />
          </AuthenticatedTemplate>
        </>
      }


      {!USE_AD_AUTHENTICATION &&
        <>
          {/*
            If you are not using AD authentication then you only need to define a router provider like the
            snippet below.
          */}
          <RouterProvider router={router} />
        </>
      }
    </div>
  );
}

export default App;
